export const SUPPORTS_OBJECT_ASSIGN = "assign" in Object;
